module.exports = __webpack_public_path__ + "img/header_m.73e7cb80.png";